import styles from './UnityHubSettingsTitle.module.scss'

export type TUnityHubSettingsTitleProps = {
  title: string
}

export const UnityHubSettingsTitle = ({ title }: TUnityHubSettingsTitleProps) => (
  <h3 className={styles.root}>{title}</h3>
)
